import DurationBadge, { DurationBadgeProps } from './DurationBadge';

export default DurationBadge;
export type { DurationBadgeProps };
